import React from 'react'
import config from 'config'

// assets
import appStoreImg from 'assets/images/appstore.svg'

const IOSDownloadLink = props => (
  <a href={config.ios.appLink} target="_blank" rel="noreferrer">
    <img className="h-14" src={appStoreImg} alt="app-store-icon" {...props} />
  </a>
)

export default IOSDownloadLink
